import { useState } from "react";
import { Button, Card, Flex, Modal, Space, Switch } from "antd";
import useCreate from "hooks/useCreate";

const WorkerPermissions = ({ data, update }) => {
  const [is_open_confirm_modal, setOpenConfirmModal] = useState(false);
  const [is_open_confirm_send_email_modal, setOpenConfirmSendEmailModal] =
    useState(false);

  const { is_saving: is_sending_link, create: sendMobileAppLink } = useCreate({
    path: `/workers/${data?.id}/send_mobile_app_link`,
    success_message:
      "Wiadomość z linkiem do pobrania aplikacji mobilnej została wysłana na adres e-mail pracownika.",
  });

  return (
    <>
      <Card style={{ margin: "24px 0" }} title="Uprawnienia">
        <Modal
          style={{ top: 45 }}
          title="Potwierdzenie"
          open={is_open_confirm_modal}
          onCancel={() => setOpenConfirmModal(false)}
          okText="Tak"
          cancelText="Nie"
          onOk={async () => {
            await update({
              has_access_to_tasks: !data?.has_access_to_tasks,
            });
            setOpenConfirmModal(false);
          }}
        >
          <p>
            Czy chcesz {data?.has_access_to_tasks ? "odebrać" : "nadać"}{" "}
            pracownikowi{" "}
            <strong>
              {data?.first_name} {data?.last_name}
            </strong>{" "}
            dostęp do priorytetów i checklisty ?
          </p>
        </Modal>
        <Modal
          style={{ top: 45 }}
          title="Potwierdzenie"
          open={is_open_confirm_send_email_modal}
          onCancel={() => setOpenConfirmSendEmailModal(false)}
          okText="Tak"
          cancelText="Nie"
          onOk={async () => {
            await sendMobileAppLink();
            setOpenConfirmSendEmailModal(false);
          }}
        >
          <p>
            Czy chcesz wysłać link do aplikacji mobilnej pracownikowi{" "}
            <strong>
              {data?.first_name} {data?.last_name}
            </strong>
            ?
          </p>
        </Modal>
        <Space>
          <span>Aplikacja mobilna - Priorytety i checklista</span>
          <Switch
            checkedChildren="Dostęp aktywny"
            unCheckedChildren="Brak dostępu"
            checked={data?.has_access_to_tasks}
            onChange={() => setOpenConfirmModal(true)}
          />
        </Space>
      </Card>
      <Card title="Aplikacja mobilna">
        <Flex justify="center">
          <Button
            type="primary"
            disabled={is_sending_link}
            onClick={() => setOpenConfirmSendEmailModal(true)}
          >
            {is_sending_link
              ? "Proszę czekać..."
              : "Wyślij link do pobrania aplikacji mobilnej"}
          </Button>
        </Flex>
      </Card>
    </>
  );
};

export default WorkerPermissions;
